import { SHOW_NOTIFICATION } from './actionType'

export const initialState = {
  isShown: false,
  message: '',
  variant: '',
}

export default function notificationReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_NOTIFICATION: {
      const { payload } = action
      const { isShown, message, variant, description } = payload
      const newState = {
        ...state,
        isShown,
        message,
        variant,
        description,
      }
      return newState
    }
    default:
      return state
  }
}
